import _ from 'lodash';

import React from 'react';
import PropTypes from 'prop-types';

export default class TruncatableText extends React.Component {
    static propTypes = {
        text: PropTypes.string,
        maxLength: PropTypes.number
    };

    static defaultProps = {
        maxLength: 100
    };

    constructor(props) {
        super(props);

        this.state = {
            expanded: false
        };
    }

    render() {
        return (
            <span className="TruncatableText">
                <span className="TruncatableText-text">{this.text}</span>
                {this.showHideButton}
            </span>
        );
    }

    get text() {
        let { text, maxLength } = this.props;

        if (this.needsTruncation && !this.state.expanded) {
            return _.truncate(text, { length: maxLength, separator: /\W/ });
        } else {
            return text;
        }
    }

    get needsTruncation() {
        return this.props.text.length > this.props.maxLength;
    }

    get showHideButton() {
        if (!this.needsTruncation) return;

        return (
            <a className="TruncatableText-toggle-button" onClick={this.toggleExpanded}>
                {this.state.expanded ? '[ show less ]' : '[ show more ]'}
            </a>
        );
    }

    toggleExpanded = () => {
        this.setState({ expanded: !this.state.expanded });
    };
}
